var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-minor size1",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }